export type LegalLanguage = 'en' | 'de';
export type LegalPageType = 'privacy' | 'impressum' | 'cookies';

export const legalPaths: Record<LegalLanguage, Record<LegalPageType, string>> = {
  en: {
    privacy: '/privacy',
    impressum: '/imprint',
    cookies: '/cookies',
  },
  de: {
    privacy: '/datenschutz',
    impressum: '/impressum',
    cookies: '/cookie-richtlinie',
  },
};

export const LEGAL_ROUTE_PATHS: string[] = [
  legalPaths.en.privacy,
  legalPaths.en.impressum,
  legalPaths.en.cookies,
  legalPaths.de.privacy,
  legalPaths.de.impressum,
  legalPaths.de.cookies,
];

export const LEGAL_REDIRECTS: { from: string; to: string }[] = [
  { from: '/privacy-policy', to: legalPaths.en.privacy },
  { from: '/cookie-policy', to: legalPaths.en.cookies },
  { from: '/legal-notice', to: legalPaths.en.impressum },
  { from: '/datenschutzerklaerung', to: legalPaths.de.privacy },
  { from: '/datenschutzerklärung', to: legalPaths.de.privacy },
];

export function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '') || '/';
  return decodeURIComponent(trimmed).toLowerCase();
}

export function getLegalFromPath(
  pathname: string
): { type: LegalPageType; language: LegalLanguage } | null {
  const normalized = normalizePath(pathname);

  for (const language of ['en', 'de'] as const) {
    for (const type of ['privacy', 'impressum', 'cookies'] as const) {
      if (legalPaths[language][type] === normalized) {
        return { type, language };
      }
    }
  }

  return null;
}

export function getCounterpartPath(pathname: string): string | null {
  const current = getLegalFromPath(pathname);
  if (!current) return null;
  const other: LegalLanguage = current.language === 'en' ? 'de' : 'en';
  return legalPaths[other][current.type];
}
